/**
 * Clerk Permissions API
 *
 * Barrister manages what their assigned clerks are permitted to do.
 * Replaces the old per-matter delegation model.
 */

import { api } from './api';

export interface ClerkPermissionRecord {
  id: string;
  role: string;
  clerk: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
    memberType: string;
    avatarUrl?: string | null;
  };
  permissions: string[];
  permissionsStatus: 'pending' | 'active';
  permissionsSetAt: string | null;
  permissionLastUpdatedAt: string | null;
  assignedAt: string;
  note: string | null;
  availablePermissions: string[];
  alwaysBlocked: string[];
}

/**
 * Barrister: list all assigned clerks with their current permissions.
 * Read-only summary (derived from the `capabilities` engine). The editor that
 * WRITES permissions is DelegationSettingsPage via clerkAccessApi. The legacy
 * write endpoint and audit-log read here were removed — they wrote/read the
 * dead `permissions[]` column.
 */
export async function fetchMyClerkPermissions(): Promise<ClerkPermissionRecord[]> {
  const res = await api.get('/permissions/my-clerks');
  return res.data.data;
}

import type { ClerkWorkspaceEntry } from './clerkWorkspaceStore';

/** Clerk: get workspace context — which barristers they support and what they can do. */
export async function fetchClerkWorkspaceContext(): Promise<ClerkWorkspaceEntry[]> {
  const res = await api.get('/permissions/workspace');
  return res.data.data;
}
